export default "__VITE_ASSET__C$z8qGmz__"